import classNames from 'classnames';
import Immutable from 'immutable';
import React from 'react';

import ParameterComponent from 'sharedreact/components/ParameterComponent';
import ResourceInputWithState from 'sharedreact/components/ResourceInputWithState';
import TextInfoField from 'sharedreact/components/TextInfoField';
import type ErrorData from 'sharedreact/data/ErrorData';

type Props<T, S> = {
  id: string,
  className?: string,
  iconClassName?: string,
  name: string,
  label: string,
  labelClassName?: string,
  value: T | null,
  placeholder: string,
  requestFocus?: boolean,
  disabled?: boolean,
  readonly?: boolean,
  tooltip?: string,
  validations?: string[],
  noSuggestions?: boolean,
  emptyValue?: T | null,

  format?: (value: T | S | null) => string,
  onChangeValue: (name: string, value: T | S | null, event?: React.FocusEvent<HTMLInputElement> | React.MouseEvent<HTMLButtonElement> | React.MouseEvent<HTMLAnchorElement> | React.KeyboardEvent<HTMLInputElement> | React.KeyboardEvent<HTMLUListElement>) => void,
  onShowResources: (filterString: string | null, name: string) => void,
  onGetSuggestions?: (filterString: string | null, onSuccess: (items: Immutable.List<S>, totalCount: number) => void, onFailure:(error: ErrorData) => void) => void,
  validate?: (name: string) => void
};

class ResourceFieldWithState<T, S = T> extends React.PureComponent<Props<T, S>> {
  override render (): React.ReactNode {
    const {
      id, className, name, label, labelClassName, value,
      placeholder, requestFocus, disabled, readonly, tooltip,
      validations, emptyValue, format,
      onChangeValue, onGetSuggestions, onShowResources,
      noSuggestions, iconClassName, validate
    } = this.props;

    if (readonly) {
      return (
        <TextInfoField id={id}
          label={label}
          value={String(value)}
        />
      );
    } else {
      return (
        <ParameterComponent
          inputId={id}
          label={label}
          labelClassName={labelClassName}
          className={classNames(className, 'esko_parameter-input-group-max500')}
        >
          <ResourceInputWithState<T, S>
            id={id}
            listIcon={iconClassName}
            name={name}
            value={value}
            placeholder={placeholder}
            noSuggestions={noSuggestions}
            requestFocus={requestFocus}
            disabled={disabled}
            tooltip={tooltip}
            validations={validations}
            onChangeValue={onChangeValue}
            onGetSuggestions={onGetSuggestions}
            onShowResources={onShowResources}
            emptyValue={emptyValue}
            format={format}
            validate={validate}
          />
        </ParameterComponent>
      );
    }
  }
}

export default ResourceFieldWithState;
